
<!-- <ul *ngIf="!!isLogged" class="mainList">
    <div class="nav-bar-div">
        <span [appTranslate]="'WELCOME'"></span>
         <span style="font-weight: 600;" [appEnglishToCyrillic]="user.Name + ' ' + user.Surname"></span>
    </div>
    <li><a routerLinkActive="current" [routerLink]="['/app-list']"> <mat-icon  fontIcon="library_books"></mat-icon>  <span [appTranslate]="'REQUIREMENTS'"></span></a></li>
    <li *ngIf="!isAdmin"><a routerLinkActive="current" [routerLink]="['/payments']">  <mat-icon  fontIcon="account_balance_wallet"></mat-icon> <span [appTranslate]="'PAYMENTS'"></span></a></li>
</ul> -->
<!-- <ul *ngIf="!isLogged" class="mainList">
    <li><a routerLinkActive="current" [routerLink]="['/login']"><span [appTranslate]="'LOGIN'"></span></a></li>

</ul> -->

<div *ngIf="!!isLogged" class="mainList">
    <div>
        <div class="welcomeWrap">
            <div>
                <h3 [appTranslate]="'WELCOME'"></h3> <span
                    [appEnglishToCyrillic]="user.Name + ' ' + user.Surname"></span>
            </div>
            <a *ngIf="!isAdmin" href="/user-profile" class="editProfile" title="Edit Profile" aria-label="Edit profile"
                (click)="onMenuItemClick()">
                <img src="/assets/images/profile-edit.svg" alt="" aria-hidden="true" />
            </a>
        </div>

        <ul>
            <!-- <li>
                <a routerLinkActive="active" [routerLink]="['/dashboard']">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M9.02 2.83992L3.63 7.03992C2.73 7.73992 2 9.22992 2 10.3599V17.7699C2 20.0899 3.89 21.9899 6.21 21.9899H17.79C20.11 21.9899 22 20.0899 22 17.7799V10.4999C22 9.28992 21.19 7.73992 20.2 7.04992L14.02 2.71992C12.62 1.73992 10.37 1.78992 9.02 2.83992Z"
                            stroke="#99AAB8" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M12 17.99V14.99" stroke="#99AAB8" stroke-width="2" stroke-linecap="round"
                            stroke-linejoin="round" />
                    </svg>
                    <span [appTranslate]="'DASHBOARD'"></span>
                </a>
            </li> -->
            <li>
                <a routerLinkActive="active" [routerLink]="['/app-list']" (click)="onMenuItemClick()">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                        <path
                            d="M21.6602 10.44L20.6802 14.62C19.8402 18.23 18.1802 19.69 15.0602 19.39C14.5602 19.35 14.0202 19.26 13.4402 19.12L11.7602 18.72C7.59018 17.73 6.30018 15.67 7.28018 11.49L8.26018 7.30001C8.46018 6.45001 8.70018 5.71001 9.00018 5.10001C10.1702 2.68001 12.1602 2.03001 15.5002 2.82001L17.1702 3.21001C21.3602 4.19001 22.6402 6.26001 21.6602 10.44Z"
                            stroke="#99AAB8" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                        <path
                            d="M15.0603 19.39C14.4403 19.81 13.6603 20.16 12.7103 20.47L11.1303 20.99C7.16034 22.27 5.07034 21.2 3.78034 17.23L2.50034 13.28C1.22034 9.30998 2.28034 7.20998 6.25034 5.92998L7.83034 5.40998C8.24034 5.27998 8.63034 5.16998 9.00034 5.09998C8.70034 5.70998 8.46034 6.44998 8.26034 7.29998L7.28034 11.49C6.30034 15.67 7.59034 17.73 11.7603 18.72L13.4403 19.12C14.0203 19.26 14.5603 19.35 15.0603 19.39Z"
                            stroke="#99AAB8" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M12.6396 8.53003L17.4896 9.76003" stroke="#99AAB8" stroke-width="1.5"
                            stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M11.6602 12.4L14.5602 13.14" stroke="#99AAB8" stroke-width="1.5" stroke-linecap="round"
                            stroke-linejoin="round" />
                    </svg>

                    <span [appTranslate]="'REQUIREMENTS'"></span>
                </a>
            </li>
            <li *ngIf="!isAdmin">
                <a routerLinkActive="active" [routerLink]="['/payments']" (click)="onMenuItemClick()">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                        <path
                            d="M18.04 13.55C17.62 13.96 17.38 14.55 17.44 15.18C17.53 16.26 18.52 17.05 19.6 17.05H21.5V18.24C21.5 20.31 19.81 22 17.74 22H6.26C4.19 22 2.5 20.31 2.5 18.24V11.51C2.5 9.44001 4.19 7.75 6.26 7.75H17.74C19.81 7.75 21.5 9.44001 21.5 11.51V12.95H19.48C18.92 12.95 18.41 13.17 18.04 13.55Z"
                            stroke="#99AAB8" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                        <path
                            d="M2.5 12.4101V7.8401C2.5 6.6501 3.23 5.59006 4.34 5.17006L12.28 2.17006C13.52 1.70006 14.85 2.62009 14.85 3.95009V7.75008"
                            stroke="#99AAB8" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                        <path
                            d="M22.5588 13.9702V16.0302C22.5588 16.5802 22.1188 17.0302 21.5588 17.0502H19.5988C18.5188 17.0502 17.5288 16.2602 17.4388 15.1802C17.3788 14.5502 17.6188 13.9602 18.0388 13.5502C18.4088 13.1702 18.9188 12.9502 19.4788 12.9502H21.5588C22.1188 12.9702 22.5588 13.4202 22.5588 13.9702Z"
                            stroke="#99AAB8" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M7 12H14" stroke="#99AAB8" stroke-width="1.5" stroke-linecap="round"
                            stroke-linejoin="round" />
                    </svg>

                    <span [appTranslate]="'PAYMENTS'"></span>
                </a>
            </li>
            <!-- <li>
                <a routerLinkActive="active" [routerLink]="['/deal']">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M9.30957 14.7L10.8096 16.2L14.8096 12.2" stroke="#909FAB" stroke-width="1.5"
                            stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M10 6H14C16 6 16 5 16 4C16 2 15 2 14 2H10C9 2 8 2 8 4C8 6 9 6 10 6Z" stroke="#909FAB"
                            stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                        <path
                            d="M16 4.02002C19.33 4.20002 21 5.43002 21 10V16C21 20 20 22 15 22H9C4 22 3 20 3 16V10C3 5.44002 4.67 4.20002 8 4.02002"
                            stroke="#909FAB" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round"
                            stroke-linejoin="round" />
                    </svg>


                    <span [appTranslate]="'DEAL'"></span>
                </a>
            </li> -->
            <li> 
                <a routerLinkActive="active" [routerLink]="['/fines']">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M19.5 12.5C19.5 11.12 20.62 10 22 10V9C22 5 21 4 17 4H7C3 4 2 5 2 9V9.5C3.38 9.5 4.5 10.62 4.5 12C4.5 13.38 3.38 14.5 2 14.5V15C2 19 3 20 7 20H17C21 20 22 19 22 15C20.62 15 19.5 13.88 19.5 12.5Z"
                            stroke="#99AAB8" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M10 4L10 20" stroke="#99AAB8" stroke-width="1.5" stroke-linecap="round"
                            stroke-linejoin="round" stroke-dasharray="5 5" />
                    </svg>

                    <span  [appTranslate]="'PAY_WITH_CARD'"></span>
                </a>
            </li>
            <!-- <li>
                <a routerLinkActive="active" [routerLink]="['/licence-application']">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12 15.5V9.5L14 11.5" stroke="#99AAB8" stroke-width="1.5" stroke-linecap="round"
                            stroke-linejoin="round" />
                        <path d="M12 9.5L10 11.5" stroke="#99AAB8" stroke-width="1.5" stroke-linecap="round"
                            stroke-linejoin="round" />
                        <path d="M2 10V15C2 20 4 22 9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H10" stroke="#99AAB8"
                            stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M2 10L10 2" stroke="#99AAB8" stroke-width="1.5" stroke-linecap="round"
                            stroke-linejoin="round" />
                    </svg>

                    <span [appTranslate]="'APPLY_FOR_LICENSE'"></span>
                </a>
            </li> -->
            <li *ngIf="!isAdmin" class="visible-xs">
                <a routerLinkActive="active" [routerLink]="['/user-profile']" (click)="onMenuItemClick()">
                    <svg width="26" height="27" viewBox="0 0 26 27" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                        <path
                            d="M12.5147 13.7423C8.72619 13.7423 5.64355 10.6598 5.64355 6.87245C5.64355 3.08264 8.72606 0 12.5147 0C16.3033 0 19.3859 3.08251 19.3859 6.87115C19.3859 10.6597 16.3033 13.7423 12.5147 13.7423ZM12.5147 2.45484C10.0801 2.45484 8.0971 4.43646 8.0971 6.87245C8.0971 9.30707 10.0787 11.2888 12.5147 11.2888C14.9493 11.2888 16.9323 9.30714 16.9323 6.87245C16.9323 4.43656 14.9494 2.45484 12.5147 2.45484Z"
                            fill="black" />
                        <path
                            d="M21.1917 26.9962H3.83807C1.72234 26.9962 0 25.2753 0 23.1595C0 19.2521 3.1749 16.0758 7.07977 16.0758H17.951C21.8548 16.0758 25.0307 19.2507 25.0307 23.1556C25.0295 25.2751 23.3073 26.9959 21.1914 26.9959L21.1917 26.9962ZM7.08009 18.5293C4.53031 18.5293 2.45516 20.6046 2.45516 23.1543C2.45516 23.9199 3.07648 24.5411 3.8395 24.5411H21.1931C21.9562 24.5411 22.5774 23.9198 22.5774 23.1581C22.5774 20.6045 20.5022 18.5293 17.9525 18.5293L7.08009 18.5293Z"
                            fill="black" />
                    </svg>

                    <span [appTranslate]="'USER_PROFILE'"></span>
                </a>
            </li>

            <li class="visible-xs">
                <button *ngIf="!!isLogged" [appTranslate]="'APPLY_FOR_LICENSE'" type="button" class="btn btn-primary"
                    aria-label="Apply for license"
                    (click)="apply()"></button>
            </li>

            <li class="visible-xs">
                <button type="button" class="btn btn-primary flex gap15" (click)="logout()">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                        <path
                            d="M8.90039 7.56023C9.21039 3.96023 11.0604 2.49023 15.1104 2.49023H15.2404C19.7104 2.49023 21.5004 4.28023 21.5004 8.75023V15.2702C21.5004 19.7402 19.7104 21.5302 15.2404 21.5302H15.1104C11.0904 21.5302 9.24039 20.0802 8.91039 16.5402"
                            stroke="#ffffff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M15.0001 12H3.62012" stroke="#ffffff" stroke-width="2" stroke-linecap="round"
                            stroke-linejoin="round" />
                        <path d="M5.85 8.6499L2.5 11.9999L5.85 15.3499" stroke="#ffffff" stroke-width="2"
                            stroke-linecap="round" stroke-linejoin="round" />
                    </svg>

                    <span [appTranslate]="'LOGOUT'"></span>
                </button>
            </li>
        </ul>
    </div>
    <!-- <div *ngIf="!isAdmin" class="sideMenuDocuments">
        <a href="/Content/documents/Права и обврски на корисникот и давателот на услугата паркирање.pdf" target="_blank"
            class="btn btn-link mobileOnly">
            <img src="/assets/images/document-text.svg" alt="" aria-hidden="true">
            <span [appTranslate]="'RIGHTS_DOCUMENTS'"></span>
        </a>
        <a href="/Content/documents/Права и обврски на корисникот и давателот на услугата паркирање.pdf" class="btn btn-link">
            <img src="/assets/images/document-text.svg" alt="" aria-hidden="true">
            <span [appTranslate]="'RIGHTS_AND_DOCUMENTS'"></span>
        </a>  
    </div> -->
</div>
<ul *ngIf="!isLogged" class="mainList">
    <li><a routerLinkActive="current" [routerLink]="['/login']"><span [appTranslate]="'LOGIN'"></span></a></li>
</ul>